import { FormControl, FormErrorMessage, Input } from '@everlywell/ui-kit';
import { PrePurchaseQuizEmailData } from 'components/PageSections/PrePurchaseQuizModal/EligibilityScreens/YouAreEligible';
import React from 'react';
import { UseFormMethods } from 'react-hook-form';

export type EmailFieldProps = {
  register: UseFormMethods['register'];
  /*
   * The errors object from react-hook-form
   */
  errors: UseFormMethods['errors'];
  wcPlusSignupEmail?: PrePurchaseQuizEmailData['email'];
  placeholder?: string;
  placeholderColor?: string;
  fontFamily?: string;
  fontColor?: string;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  /**
   * Shows lightGrey border instead of uiGrey
   */
  isVariant?: boolean;
};

/**
 * Field for the user to input their email
 */
function EmailField({
  register,
  errors,
  wcPlusSignupEmail,
  placeholder = 'Your Email',
  placeholderColor,
  fontFamily,
  fontColor,
  onBlur,
  onKeyDown,
  isVariant = false,
}: EmailFieldProps): JSX.Element {
  return (
    <FormControl isRequired isInvalid={errors?.email}>
      <Input
        aria-label="Email address"
        placeholder={placeholder}
        name="email"
        type="email"
        defaultValue={wcPlusSignupEmail || ''}
        {...(isVariant && { borderColor: 'tints.lightGrey' })}
        {...(fontFamily && { fontFamily })}
        {...(fontColor && { color: fontColor })}
        {...(placeholderColor && {
          _placeholder: {
            color: placeholderColor,
            opacity: 1,
          },
        })}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        ref={register({
          required: 'Please enter an email address',
          pattern: {
            value:
              // eslint-disable-next-line no-control-regex
              /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i,
            message: 'Please enter a valid email address',
          },
        })}
      />
      <FormErrorMessage>{errors?.email?.message}</FormErrorMessage>
    </FormControl>
  );
}

export default EmailField;
